import { render, staticRenderFns } from "./qualityOrderInfo.vue?vue&type=template&id=116d4580&"
import script from "./qualityOrderInfo.vue?vue&type=script&lang=js&"
export * from "./qualityOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./qualityOrderInfo.vue?vue&type=style&index=0&id=116d4580&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports